<template>
  <el-container class="foot">
    <el-container class="foot-content">
      <!-- <el-row :gutter="20" class="foot-main" type="flex" align="middle"> -->
      <el-col :span="6">
        <el-card>
          <el-link class="foot-logo" href="/index" target="_blank" :underline="false">
            MARKIT
          </el-link>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card>
          <div slot="header" class="clearfix">
            <span>关于</span>
          </div>
          <div style="text-align: justify;">
            MARKIT 导航，提供最精华有趣的内容 。 本站仅为网址导航，网站来源于网络，对其内容不负任何责任，若有问题，请联系我们。
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card>
          <div slot="header" class="clearfix">
            <span>联系方式</span>
          </div>
          <div>
            <el-tooltip placement="top">
              <div slot="content">
                <el-image style="width: 160px;" :src="require('@/assets/public.png')" :fit="'fill'"></el-image>
              </div>
              <span style="cursor: pointer;">客服微信：cafeit</span>
            </el-tooltip>
          </div>
          <!-- <div>
            <el-tooltip placement="top">
              <div slot="content">
                <el-image style="width: 160px;" :src="require('@/assets/public.png')" :fit="'fill'"></el-image>
              </div>
              <el-link href="###" target="_blank" :underline="false">客服微信：cafeit</el-link>
            </el-tooltip>
          </div> -->
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card>
          <div slot="header" class="clearfix">
            <span>公众号</span>
          </div>
          <div class="demo-image__preview">
            <el-image :src="url" :preview-src-list="srcList" :fit="'fill'"></el-image>
          </div>
        </el-card>
      </el-col>
      <!-- </el-row> -->
    </el-container>
  </el-container>
</template>

<script>
  export default {
    name: "Foot",
    data() {
      return {
        url: require('@/assets/public.jpg'),
        srcList: [
          require('@/assets/public.jpg'),
          require('@/assets/cheat.png')
        ]
      }
    },
    methods: {}
  }
</script>

<style scoped lang="less">
  .foot {
    width: 100%;
    color: #606266;
    background: #FFFFFF;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    // white-space: nowrap;
    font-size: 14px;
    position: relative;
    z-index: 1;

    .foot-content {
      max-width: 1200px;
      height: 100%;
      margin: 20px auto;
    }

    .el-card {
      background-color: transparent;
      border: none;
      box-shadow: none;

      .foot-logo {
        color: #409eff;
        font-size: 50px;
      }

      /deep/ .el-card__header {
        border: none !important;
        padding-bottom: 0;
        font-weight: 600;
        font-size: 16px;
      }

      .demo-image__preview {
        width: 100px;
        min-height: 100px;
        border: 1px solid #EEEEEE;
        background: #EEEEEE;
        padding: 7px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue